import React from 'react'
import { ErrorMessage } from '@hookform/error-message';

function UCDateInputV1({
  label,
  name,
  placeholder,
  disabled,
  errors,
  className,
  register
}) {
  return (
    <div className={`uc-date-input-v1 ${className}`}>
      <p className='label'>{label}</p>
      <div className={`textarea-wrapper ${disabled ? "disabled" : ""}`}>
        <input
          {...register}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          type="date"
        />
      </div>
      {errors ? <ErrorMessage
        errors={errors}
        name="gender"
        render={({ message }) => <p className='text-xs text-red-0'>{message}</p>}
      /> : ""}
    </div>
  )
}

UCDateInputV1.defaultProps = {
  label: "",
  error: "",
  name: "",
  placeholder: "",
  disabled: false,
  onChange: () => { }
}

export default UCDateInputV1